export enum COMMENT_CARD_TYPES {
	Default = 'default',
	ProgramRules = 'programRules',
	Message = 'message',
	InternalNote = 'internalNote',
	APPLICATION_EXCEPTION = 'applicationException',
	PARTICIPANT_ALERT = 'participantAlert',
	APPLICATION_TOTALS = 'applicationTotals',
	SYSTEM_MESSAGE = 'systemMessage',
	PAYMENT = 'payment',
	STOP_PAYMENT = 'stopPayment',
	REFUND = 'refund',
	COURSE = 'course',
	APPLICATION_EXPENSE = 'applicationExpense',
	PARTICIPANT_HISTORY = 'participantHistory',
	SAVINGS = 'Savings',
	GENERAL = 'General',
	APPEAL_REASON = 'appealReason',
	PARTICIPANT_EXCEPTION = 'participantException',
	APPLICATION_EXCEPTION_DELETED = 'applicationExceptionDeleted',
}
